import EntityLink from '../../../../../../containers/EntityLink'
import {getProject} from '../../../../../../selectors'
import type {ProjectId} from '../../../../../../types'
import ProjectOrBuildTypeIcon from '../../../../../common/ProjectOrBuildTypeIcon/ProjectOrBuildTypeIcon'
import {EntityIconType} from '../../../../../common/ProjectOrBuildTypeIcon/ProjectOrBuildTypeIcon.types'

import {useAppSelector} from 'src/hooks/react-redux'

type ProjectLinkProps = {
  projectId: ProjectId
}

export default function ProjectLink({projectId}: ProjectLinkProps) {
  const name = useAppSelector(state => getProject(state, projectId)?.name)
  return (
    <EntityLink projectId={projectId}>
      {WrapText => (
        <>
          <ProjectOrBuildTypeIcon type={EntityIconType.PROJECT} />
          <WrapText>{name}</WrapText>
        </>
      )}
    </EntityLink>
  )
}
